export default "__VITE_ASSET__WHcZi1hM__"